import Control from 'ol/control/Control'

import { updateLegend } from './legend'
import { updateSVG } from '../map/d3Renderer'
import { newBaseMap, vectorLayer } from '../map/layers'
import { link, getLayerById, mapsToBeSteered, setMapsToBeSteered } from '../map/tools'
import { getMapsToBeSteered } from '../qualityCheck/getset'
import { debug, locallyAr5 } from '../storage'

import graatonerUrl from '/img/basemaps/graatoner.png';
import fargerUrl from '/img/basemaps/farger.png';
import grunnkartUrl from '/img/basemaps/grunnkart.png';
import rasterUrl from '/img/basemaps/raster.png';
import flybilderUrl from '/img/basemaps/flybilder.png';
import ingenUrl from '/img/basemaps/ingen.png';

const imgUrl = {
  graatoner: graatonerUrl,
  farger: fargerUrl,
  grunnkart: grunnkartUrl,
  raster: rasterUrl,
  flybilder: flybilderUrl,
  ingen: ingenUrl
};

// let fly;
export const loadBasemapSelector = (basemaps) => {
  const mobile = (window.innerWidth < 860);

  const s = document.getElementById('bgSelector');
  let tr;
  basemaps.forEach((bg, i) => {
    if (!tr || (tr.cells.length % 3 === 0 && mobile)) {
      tr = document.createElement('tr');
      s.append(tr);
    }
    // console.log(tr.cells.length);
    // console.log(i + 1, bg.id);
    const e = document.createElement('td');
    e.id = bg.id;
    e.className = 'bg-layer';
    const url = new URLSearchParams(window.location.search).get('map');
    if (bg.id === url) e.classList.add('bg-highlight');
    e.onclick = () => {
      const bmIndex = mapsToBeSteered[0].get('groupPosition') - 1; // before WMS
      const bm = mapsToBeSteered[0].getLayers().item(bmIndex);
      const currentBasemap = bm.get('type');
      const id = bg.id;
      if (currentBasemap !== id) {
        const sid = currentBasemap.replace('graatoner', 'gråtoneWMS');
        getLayerById(sid)?.setVisible(false);
        mapsToBeSteered.forEach(m => {
          const itsOwnProjection = m.getView().getProjection().getCode();
          const mini = (m.getTarget() !== 'map');
          const bm_new = newBaseMap(id, itsOwnProjection.slice(-2), mini);
          m.tileQueue_.tilesLoading_ = 0; // do not wait for previous bm to load
          m.getLayers().setAt(bmIndex, bm_new);
        });
        link.update('map', id);
        // adjust style (red border):
        document.getElementById(currentBasemap)?.classList.remove('bg-highlight');
        e.classList.add('bg-highlight');
        if (locallyAr5) {
          // Fill colour updates according to basemap:
          updateSVG(); // when postgis is renderer through D3
          vectorLayer.changed(); // when postgis is renderer through OpenLayers
          if (debug < 12) console.log('change AR5 wms and its legend accordingly');
          // const fly = (id === 'flybilder');
          // const k7 = getLayerById('arealtypeWMS');
          // // if (k7) k7.setVisible(fly ? false : true);
          // const k13 = getLayerById('ar5_13WMS');
          // // if (k13) k13.setVisible(fly ? false : true);
          // if (k7 || k13) {
          //   getLayerById('ar5orthoWMS').setVisible(fly ? true : false);
          // }
          updateLegend();
        }
      }
      s.classList.add('closed');
    };
    const img = document.createElement('img');
    img.src = imgUrl[bg.id];
    img.alt = bg.label;
    e.append(img);
    const labelDiv = document.createElement('div');
    labelDiv.innerHTML = bg.label;
    e.append(labelDiv);
    e.classList.add(mobile ? 'bg-mobile' : 'bg-desktop');
    tr.append(e);
  });

}; // loadBasemapSelector

const highlightSelectorAccordingToMap = (m) => {
  // highlight basemap selector:
  const bmIndex = m.get('groupPosition') - 1; // before WMSes
  const currentBasemap = m.getLayers().getArray()[bmIndex].get('type');
  const highlighted = document.getElementsByClassName('bg-highlight');
  highlighted[0].classList.remove('bg-highlight');
  const toBeHighlighted = document.getElementById(currentBasemap);
  if (toBeHighlighted) toBeHighlighted.classList.add('bg-highlight');
};

// Base map button.
export class BaseMapControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    if (options.id) { button.id = options.id; }
    button.title = 'Bakgrunnskart';
    button.innerHTML = '<i class="material-icons">map</i>';
    // button.style.bottom = options.bottom;

    const element = document.createElement('div');
    element.className = 'base-maps ol-unselectable ol-control';
    element.appendChild(button);

    super({ element: element, target: options.target });

    button.addEventListener('click', this.toggleChoices.bind(this), false);
    button.addEventListener('blur', this.hideChoices.bind(this), false);
  }

  toggleChoices = (e) => {
    const maps = getMapsToBeSteered(e.currentTarget.id);
    setMapsToBeSteered(maps);
    highlightSelectorAccordingToMap(maps[0]);
    document.getElementById('bgSelector').classList.toggle('closed');
  };
  hideChoices = (e) => {
    if (document.getElementById('bgSelector').matches(':hover')) {
    // if (document.getElementById('bgSelector').querySelector(':hover')) {
      return;
    }
    // console.log(e.explicitOriginalTarget); // only FF
    document.getElementById('bgSelector').classList.add('closed');
  };
}
